/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type RouteTypeName = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const RouteTypeName = {
    NUMBER_1: 1 as RouteTypeName,
    NUMBER_2: 2 as RouteTypeName,
    NUMBER_3: 3 as RouteTypeName,
    NUMBER_4: 4 as RouteTypeName,
    NUMBER_5: 5 as RouteTypeName,
    NUMBER_6: 6 as RouteTypeName,
    NUMBER_7: 7 as RouteTypeName,
    NUMBER_8: 8 as RouteTypeName
};